import React from 'react'
import {ColorPalette} from "../../../../color-coding/color-coding"

const debug = false
// const debug = "FieldIconWithColor_PickerValueNotEmpty"

export default function FieldIconWithColor_PickerValueNotEmpty(props:any) {

    const {icon, color} = props.model[props.field.fieldId]

    debug && console.log(debug, 'render', icon, color, props.field.fieldId, props.model)

    const classes       = Classes("ui5-field-picker", props.className)
    const iconClasses   = Classes("ui5-ico-16", icon)

    const iconStyle = {
        color: gd.skin.colors.mainColor({
            colorNumber: color,
            corePalette: ColorPalette.CORE
        })
    }

    return (
        <div className={classes} onClick={props.onClick}>
            <div className  = {iconClasses}
                 style      = {iconStyle}/>
            {props.children}
        </div>
    )
}
